import { useMemo, useState } from "react";

import Contact from "../../Components/Contact/Contact";
import Footer from "../../Components/Footer/Footer";
import Navbar2 from "../Navbar2/Navbar2"



import {
    featuredProjects,
    getProjectsByCategory,
    portfolioStats,
    projectCategories
} from "../../Data/project";




import "./Portfolio.css";

const Portfolio = () => {

/* ===========================
   STATE
=========================== */

const [activeCategory, setActiveCategory] = useState("All");
const [searchQuery, setSearchQuery] = useState("");

/* ===========================
   DERIVED DATA
=========================== */

const featuredProject = featuredProjects[0];

const filteredProjects = useMemo(() => {

    return getProjectsByCategory(activeCategory).filter(project => {

        const search = searchQuery.toLowerCase();

        return (
            project.title.toLowerCase().includes(search) ||
            project.category.toLowerCase().includes(search) ||
            project.technologies.some(technology =>
                technology.toLowerCase().includes(search)
            )
        );

    });

}, [activeCategory, searchQuery]);

    /* ===========================
       HANDLERS
    =========================== */

    const handleCategoryChange = (category) => {
        setActiveCategory(category);
    };

    return (
        <main className="portfolio">
            <Navbar2/>

            {/* ===========================
                HERO
            =========================== */}

            <section className="portfolio-hero">

                <div className="portfolio-container">

                   

                    <h1 className="portfolio-title">
                        Our Portfolio
                    </h1>

                    <p className="portfolio-description">
                        Explore our collection of web applications, mobile apps,
                        AI-powered products, and enterprise solutions designed
                        to solve real business challenges
                    </p>

                </div>

            </section>

            {/* ===========================
                PORTFOLIO STATISTICS
            =========================== */}

            <section className="portfolio-statistics">

                <div className="portfolio-container">

                    <div className="portfolio-stats-grid">

                        <div className="portfolio-stat-card">

                            <h2>
                                {portfolioStats.totalProjects}
                            </h2>

                            <p>
                                Projects
                            </p>

                        </div>

                        <div className="portfolio-stat-card">

                            <h2>
                                {portfolioStats.types}
                            </h2>

                            <p>
                                Types
                            </p>

                        </div>

                        <div className="portfolio-stat-card">

                            <h2>
                                {portfolioStats.categories}
                            </h2>

                            <p>
                                Categories
                            </p>

                        </div>

                        <div className="portfolio-stat-card">

                            <h2>
                                {portfolioStats.technologies}+
                            </h2>

                            <p>
                                Technologies
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* ===========================
                FEATURED PROJECT
            =========================== */}

            <section className="featured-project">

                <div className="portfolio-container">

                    <div className="featured-project-card">

                        <div className="featured-project-image">

                            <img
                                src={featuredProject.image}
                                alt={featuredProject.title}
                            />

                        </div>

                        <div className="featured-project-content">

                            <span className="project-category">
                                {featuredProject.category}
                            </span>

                            <h2 className="featured-project-title">
                                {featuredProject.title}
                            </h2>

                         

                            <p className="featured-project-overview">
                                {featuredProject.description}
                            </p>

                            <div className="featured-technologies">
                                {(featuredProject?.technologies || [])
                                    .slice(0, 6)
                                    .map((technology) => (
                                        <span
                                            key={technology}
                                            className="technology-pill"
                                        >
                                            {technology}
                                        </span>
                                    ))}
                            </div>
                            <hr className="featured-divider"/>

                          

                        </div>

                    </div>

                </div>

            </section>

                        {/* ===========================
                PORTFOLIO CONTROLS
            =========================== */}

            <section className="portfolio-controls">

                <div className="portfolio-container">

                    <div className="portfolio-toolbar">

                        <div className="portfolio-search">

                            <input
                                type="text"
                                placeholder="Search projects..."
                                value={searchQuery}
                                onChange={(e)=>setSearchQuery(e.target.value)}
                            />

                        </div>

                        <div className="portfolio-filter-buttons">

                            {projectCategories.map(category => (

                                <button
                                    key={category}
                                    className={`filter-btn ${
                                        activeCategory === category ? "active" : ""
                                    }`}
                                    onClick={() => handleCategoryChange(category)}
                                >
                                    {category}
                                </button>

                            ))}

                        </div>

                    </div>

                </div>

            </section>



                {/* ===========================
                    PROJECTS
                =========================== */}

                <section className="portfolio-projects">

                    <div className="portfolio-container">

                        <div className="portfolio-grid">

                            {filteredProjects.map(project => (

                                <article
                                    key={project.id}
                                    className="portfolio-card"
                                >

                                    <div className="portfolio-card-image">

                                        <img
                                            src={project.image}
                                            alt={project.title}
                                        />

                                    </div>

                                    <div className="portfolio-card-content">

                                        <span className="project-category">
                                            {project.category}
                                        </span>

                                        <h3 className="portfolio-card-title">
                                            {project.title}
                                        </h3>

                                        <p className="portfolio-card-description">
                                            {project.description}
                                        </p>

                                       <div className="portfolio-card-technologies">
                                            {(project?.technologies || [])
                                                .slice(0, 4)
                                                .map((technology) => (
                                                    <span
                                                        key={technology}
                                                        className="technology-pill"
                                                    >
                                                        {technology}
                                                    </span>
                                                ))}
                                        </div>

                                                                                {
                                            project.liveUrl && (
                                                <a
                                                    href={project.liveUrl}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="live-url"
                                                >
                                                    View Live →
                                                </a>
                                            )
                                        }
                                       

                                    </div>

                                </article>

                            ))}

                        </div>

                    </div>

                </section>
                        



            

            {/* ===========================
                CONTACT
            =========================== */}

            <Contact
                tag="CONTACT US"
                title="Let's Build Something Amazing Together"
                description="Ready to transform your ideas into reality? Get in touch with our team and let's discuss your next project."
                showMap={true}
                background="black"
            />

            {/* ===========================
                FOOTER
            =========================== */}

            <Footer />

        </main>
    );

};

export default Portfolio;